// import React, { useEffect, useState, useContext } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import axios from 'axios';
// import { AiOutlineFrown } from 'react-icons/ai';
// import Header from '../Header/Header';
// import Footer from '../Footer/Footer';
// import { CartContext } from '../Cart/CartContext'; // ✅ Import CartContext
// import { WishlistContext } from '../Wishlist/WishlistContext'; // (Optional) if using wishlist
// import { FaRegBookmark } from 'react-icons/fa';

// const FilteredProducts = () => {

//     const { superCatName, subCatName, filterType } = useParams();

//     console.log(superCatName, subCatName)

//     const navigate = useNavigate();

//     const { cartItems, addToCart, removeFromCart } = useContext(CartContext); // ✅ Use Cart Context
//     const { addToWishlist } = useContext(WishlistContext); // ✅ (Optional) Use Wishlist Context

//     const [products, setProducts] = useState([]);
//     const [loading, setLoading] = useState(true);

//     const [selectedVariants, setSelectedVariants] = useState({});
//     const [variantDropdownOpen, setVariantDropdownOpen] = useState({});
//     const [quantities, setQuantities] = useState({});

//     const decodedSuperCat = decodeURIComponent(superCatName || '');
//     const decodedSubCat = decodeURIComponent(subCatName || '');

//     useEffect(() => {
//         const fetchProducts = async () => {
//             try {
//                 const res = await axios.get('https://api.glocart.in/pages/api/products/get');
//                 const allProducts = res.data;

//                 const filtered = allProducts.filter(prod => {
//                     const matchesCategory = decodedSuperCat
//                         ? prod.category?.toLowerCase() === decodedSuperCat.toLowerCase()
//                         : true;
//                     const matchesSubCategory = decodedSubCat
//                         ? prod.sub_category?.toLowerCase() === decodedSubCat.toLowerCase()
//                         : true;

//                         console.log(matchesCategory)

//                     return matchesCategory && matchesSubCategory;
//                 });


//                 const defaultsVar = {};
//                 const defaultsQty = {};

//                 filtered.forEach(prod => {
//                     const cartItem = cartItems.find(ci => ci.productId === prod.id);
//                     if (cartItem) {
//                         const matchedVariant = prod.variants.find(v => v.id === cartItem.variantId);
//                         defaultsVar[prod.id] = matchedVariant || prod.variants[0];
//                         defaultsQty[prod.id] = cartItem.quantity;
//                     } else {
//                         defaultsVar[prod.id] = prod.variants[0];
//                         defaultsQty[prod.id] = 0;
//                     }
//                 });

//                 setProducts(filtered);
//                 setSelectedVariants(defaultsVar);
//                 setQuantities(defaultsQty);
//                 setLoading(false);
//             } catch (err) {
//                 console.error('Error fetching products:', err);
//                 setLoading(false);
//             }
//         };

//         fetchProducts();
//     }, [filterType, cartItems]);

//     const handleToggleDropdown = (productId) => {
//         setVariantDropdownOpen(prev => ({
//             ...prev,
//             [productId]: !prev[productId]
//         }));
//     };

//     const handleSelectVariant = (productId, variant) => {
//         setSelectedVariants(prev => ({
//             ...prev,
//             [productId]: variant
//         }));
//         setVariantDropdownOpen(prev => ({
//             ...prev,
//             [productId]: false
//         }));

//         const cartItem = cartItems.find(ci => ci.productId === productId && ci.variantId === variant.id);
//         setQuantities(prev => ({
//             ...prev,
//             [productId]: cartItem ? cartItem.quantity : 0
//         }));
//     };

//     const computeFinalPrice = (variant) => {
//         if (!variant) return 0;
//         if (variant.discount && variant.discount > 0) {
//             return Math.round(variant.price - (variant.price * variant.discount) / 100);
//         }
//         return variant.price;
//     };

//     return (
//         <>
//             <Header />

//             <div className="container" style={{ marginTop: '20px', maxWidth: 1200, padding: '0 20px' }}>
//                 <h4 style={{ textTransform: 'uppercase', marginBottom: '20px' }}>
//                     {superCatName ? superCatName.replace('-', ' ') : 'All Products'}
//                     {subCatName ? ` / ${subCatName.replace('-', ' ')}` : ''}
//                 </h4>
//                 <hr></hr>
//                 {loading ? (
//                     <p>Loading products...</p>
//                 ) : products.length === 0 ? (
//                     <div className="text-center mt-5" style={{ padding: '40px 20px' }}>
//                         <AiOutlineFrown size={80} color="#0057A0" />
//                         <h4 className="mt-4 text-muted" style={{ fontWeight: 'bold' }}>
//                             No products found for "<span style={{ color: '#0057A0' }}>{filterType?.replace('-', ' ')}</span>"
//                         </h4>
//                         <p className="text-secondary" style={{ marginTop: 10 }}>
//                             Try exploring other categories or filters.
//                         </p>

//                         <button
//                             onClick={() => navigate('/')}
//                             style={{
//                                 marginTop: 20,
//                                 backgroundColor: '#0057A0',
//                                 color: '#fff',
//                                 border: 'none',
//                                 padding: '10px 24px',
//                                 borderRadius: '6px',
//                                 fontSize: '16px',
//                                 cursor: 'pointer',
//                                 transition: 'all 0.3s ease'
//                             }}
//                             onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#b71c1c'}
//                             onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#0057A0'}
//                         >
//                             🛒 Shop Now
//                         </button>
//                     </div>

//                 ) : (
//                     <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 20, }}>
//                         {products.map(p => {
//                             const variant = selectedVariants[p.id];
//                             const qty = quantities[p.id] || 0;
//                             const finalPrice = computeFinalPrice(variant);
//                             const hasDiscount = variant?.discount > 0;

//                             return (
//                                 <div key={p.id} style={{ border: '1px solid #e0e0e0', background: '#fff', borderRadius: '10px', position: 'relative' }}>
//                                     {hasDiscount && (
//                                         <div style={{ position: 'absolute', top: 8, left: 8, background: '#4caf50', color: '#fff', padding: '2px 6px', fontSize: 12, borderRadius: '10px' }}>
//                                             {variant.discount}% OFF
//                                         </div>
//                                     )}

//                                     <div style={{ margin: '16px', border: '1px solid #eee', borderRadius: '10px', backgroundColor: '#fafafa', padding: 8 }}>
//                                         <div onClick={() => navigate(`/product/${p.id}`)} style={{ cursor: 'pointer' }}>
//                                             <img src={p.image_1} alt={p.name} style={{ width: '100%', height: 180, objectFit: 'contain' }} />
//                                         </div>
//                                     </div>

//                                     <div style={{ padding: 10 }}>
//                                         <p style={{ fontSize: 11, color: '#4caf50', marginBottom: 4 }}>
//                                             ⚡ {p.category}
//                                         </p>
//                                         <p style={{ fontSize: 13, margin: 0 }}>{p.brand}</p>
//                                         <h4 style={{ fontSize: 14, margin: '4px 0 8px' }}>{p.name}</h4>

//                                         {/* Variant Dropdown */}
//                                         <div style={{ position: 'relative', marginBottom: 10 }}>
//                                             <div
//                                                 style={{
//                                                     border: '1px solid #ccc',
//                                                     padding: '6px 8px',
//                                                     backgroundColor: '#fff',
//                                                     cursor: 'pointer',
//                                                     fontSize: '13px'
//                                                 }}
//                                                 onClick={() => handleToggleDropdown(p.id)}
//                                             >
//                                                 <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//                                                     <span style={{ fontWeight: 'bold' }}>₹{finalPrice}</span>
//                                                     {hasDiscount && (
//                                                         <>
//                                                             <span style={{ textDecoration: 'line-through', color: '#999' }}>₹{variant.price}</span>
//                                                             <span style={{ color: 'green', fontWeight: 'bold' }}>{variant.discount}% OFF</span>
//                                                         </>
//                                                     )}
//                                                 </div>
//                                             </div>

//                                             {variantDropdownOpen[p.id] && (
//                                                 <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #ccc', zIndex: 1000, marginTop: 4, maxHeight: 200, overflowY: 'auto' }}>
//                                                     {p.variants.map(v => {
//                                                         const vFinal = computeFinalPrice(v);
//                                                         return (
//                                                             <div key={v.id} onClick={() => handleSelectVariant(p.id, v)} style={{ padding: '8px', borderBottom: '1px solid #eee', backgroundColor: variant?.id === v.id ? '#f6f6f6' : '#fff', cursor: 'pointer', fontSize: '13px' }}>
//                                                                 <div>
//                                                                     <strong>{v.unit_value} {v.unit}</strong>{' '}
//                                                                     {v.discount > 0 && (
//                                                                         <span style={{ color: 'green', fontWeight: 'bold' }}>{v.discount}% OFF</span>
//                                                                     )}
//                                                                 </div>
//                                                                 <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 4 }}>
//                                                                     <span style={{ fontWeight: 'bold' }}>₹{vFinal}</span>
//                                                                     {v.discount > 0 && (
//                                                                         <span style={{ textDecoration: 'line-through', color: '#999' }}>₹{v.price}</span>
//                                                                     )}
//                                                                     <span style={{ fontSize: 11, backgroundColor: '#e0f7e9', color: '#4caf50', padding: '2px 6px', borderRadius: 4, fontWeight: 'bold' }}>
//                                                                         ⚡ Select
//                                                                     </span>
//                                                                 </div>
//                                                             </div>
//                                                         );
//                                                     })}
//                                                 </div>
//                                             )}
//                                         </div>

//                                         <div style={{ fontSize: 15, fontWeight: 'bold' }}>
//                                             ₹{finalPrice}
//                                             {hasDiscount && (
//                                                 <span style={{ fontSize: 13, color: '#999', textDecoration: 'line-through', marginLeft: 6 }}>
//                                                     ₹{variant.price}
//                                                 </span>
//                                             )}
//                                         </div>

//                                         {/* Add to Cart Controls */}
//                                         <div className='mt-5' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 10 }}>
//                                             <button style={{ border: '1px solid #ccc', background: '#fff', borderRadius: '6px', padding: '8px', fontSize: '16px', cursor: 'pointer' }} onClick={() => { addToWishlist(p, variant); alert(`${p.name} saved to wishlist!`); }}>
//                                                 <FaRegBookmark />
//                                             </button>


//                                             {qty > 0 ? (
//                                                 <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #0057A0', borderRadius: 6, overflow: 'hidden' }}>
//                                                     <button
//                                                         onClick={() => {
//                                                             const newQty = qty - 1;
//                                                             if (newQty <= 0) {
//                                                                 setQuantities(prev => ({ ...prev, [p.id]: 0 }));
//                                                                 removeFromCart(p.id, variant.id);
//                                                             } else {
//                                                                 setQuantities(prev => ({ ...prev, [p.id]: newQty }));
//                                                                 addToCart({
//                                                                     productId: p.id,
//                                                                     variantId: variant.id,
//                                                                     name: p.name,
//                                                                     image: p.image_1,
//                                                                     price: finalPrice
//                                                                 }, -1);
//                                                             }
//                                                         }}
//                                                         style={{ background: '#0057A0', color: '#fff', padding: '6px 35px', border: 'none' }}
//                                                     >−</button>
//                                                     <div style={{ padding: '6px 12px', fontSize: 14 }}>{qty}</div>
//                                                     <button
//                                                         onClick={() => {
//                                                             const newQty = qty + 1;
//                                                             setQuantities(prev => ({ ...prev, [p.id]: newQty }));
//                                                             addToCart({
//                                                                 productId: p.id,
//                                                                 variantId: variant.id,
//                                                                 name: p.name,
//                                                                 image: p.image_1,
//                                                                 price: finalPrice
//                                                             }, 1);
//                                                         }}
//                                                         style={{ background: '#0057A0', color: '#fff', padding: '6px 35px', border: 'none' }}
//                                                     >+</button>
//                                                 </div>
//                                             ) : (
//                                                 <button
//                                                     onClick={() => {
//                                                         setQuantities(prev => ({ ...prev, [p.id]: 1 }));
//                                                         addToCart({
//                                                             productId: p.id,
//                                                             variantId: variant.id,
//                                                             name: p.name,
//                                                             image: p.image_1,
//                                                             price: finalPrice
//                                                         }, 1);
//                                                     }}
//                                                     style={{ padding: '6px 90px', border: '1px solid #0057A0', borderRadius: 6, background: '#fff', color: '#0057A0' }}
//                                                 >
//                                                     Add
//                                                 </button>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>
//                             );
//                         })}
//                     </div>
//                 )}
//             </div>
//             <Footer />
//         </>
//     );
// };

// export default FilteredProducts;



import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { AiOutlineFrown } from 'react-icons/ai';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { CartContext } from '../Cart/CartContext';
import { WishlistContext } from '../Wishlist/WishlistContext';
import { FaRegBookmark } from 'react-icons/fa';
import { FcBookmark } from "react-icons/fc";
import { LuSettings2 } from "react-icons/lu";
import { VscSettings } from "react-icons/vsc";

import ReactCountryFlag from "react-country-flag";
import { countryCodeMap } from "../countryMap/countryMap";

const FilteredProducts = () => {

    const { superCatName, subCatName, filterType } = useParams();
    const navigate = useNavigate();

    const { cartItems, addToCart, removeFromCart } = useContext(CartContext);
    const { addToWishlist } = useContext(WishlistContext);

    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    const [selectedVariants, setSelectedVariants] = useState({});
    const [variantDropdownOpen, setVariantDropdownOpen] = useState({});
    const [quantities, setQuantities] = useState({});

    const decodedSuperCat = decodeURIComponent(superCatName || '');
    const decodedSubCat = decodeURIComponent(subCatName || '');

    const [isFilterOpen, setIsFilterOpen] = useState(false);

    console.log('this is FilterProducts')
    console.log('this is products',products)
    console.log('this is selectedVariants',selectedVariants)
    console.log('this is quantities',quantities)

    // Fetch Products
    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const res = await axios.get('https://api.glocart.in/pages/api/products/get');
                const allProducts = res.data;

                const filtered = allProducts.filter(prod => {
                    const matchesCategory = decodedSuperCat
                        ? prod.category?.toLowerCase() === decodedSuperCat.toLowerCase()
                        : true;

                    const matchesSubCategory = decodedSubCat
                        ? prod.sub_category?.toLowerCase() === decodedSubCat.toLowerCase()
                        : true;

                    return matchesCategory && matchesSubCategory;
                });

                const defaultsVar = {};
                const defaultsQty = {};

                filtered.forEach(prod => {
                    const cartItem = cartItems.find(ci => ci.productId === prod.id);

                    if (cartItem) {
                        const matchedVariant = prod.variants.find(v => v.id === cartItem.variantId);
                        defaultsVar[prod.id] = matchedVariant || prod.variants[0];
                        defaultsQty[prod.id] = cartItem.quantity;
                    } else {
                        defaultsVar[prod.id] = prod.variants[0];
                        defaultsQty[prod.id] = 0;
                    }
                });

                setProducts(filtered);
                setSelectedVariants(defaultsVar);
                setQuantities(defaultsQty);
                setLoading(false);

            } catch (err) {
                console.error('Error fetching products:', err);
                setLoading(false);
            }
        };

        fetchProducts();

    }, [filterType, cartItems]);

    // Toggle Variant Dropdown
    const handleToggleDropdown = (productId) => {
        setVariantDropdownOpen(prev => ({
            ...prev,
            [productId]: !prev[productId]
        }));
    };

    // Select Variant
    const handleSelectVariant = (productId, variant) => {
        setSelectedVariants(prev => ({
            ...prev,
            [productId]: variant
        }));

        setVariantDropdownOpen(prev => ({
            ...prev,
            [productId]: false
        }));

        const cartItem = cartItems.find(ci => ci.productId === productId && ci.variantId === variant.id);

        setQuantities(prev => ({
            ...prev,
            [productId]: cartItem ? cartItem.quantity : 0
        }));
    };

    const computeFinalPrice = (variant) => {
        if (!variant) return 0;
        if (variant.discount > 0) {
            return Math.round(variant.price - (variant.price * variant.discount) / 100);
        }
        return variant.price;
    };


    // FILTER STATES
    const [allBrands, setAllBrands] = useState([]);
    const [allCountries, setAllCountries] = useState([]);
    const [maxPrice, setMaxPrice] = useState(0);
    const [sortType, setSortType] = useState(""); // "low-high" | "high-low" | ""

    const [selectedBrands, setSelectedBrands] = useState([]);
    const [selectedCountries, setSelectedCountries] = useState([]);
    const [availability, setAvailability] = useState(""); // "in" | "out" | ""
    const [priceRange, setPriceRange] = useState(0);
    // 🔥 Build Filters When Products Change
    useEffect(() => {
        if (products.length === 0) return;

        // BRAND LIST
        const brands = [...new Set(products.map(p => p.brand))];
        setAllBrands(brands);

        // COUNTRY LIST (super category)
        const countries = [...new Set(products.map(p => p.super_category))];
        setAllCountries(countries);

        // MAX PRICE
        let highest = 0;
        products.forEach(prod => {
            prod.variants.forEach(v => {
                const price = computeFinalPrice(v);
                if (price > highest) highest = price;
            });
        });

        setMaxPrice(highest);
        setPriceRange(highest);

    }, [products]);


    const [wishlist, setWishlist] = useState({}); // mapping key -> true

    useEffect(() => {
        const user = JSON.parse(sessionStorage.getItem('userData'));
        if (!user?.id) return;

        const fetchWishlist = () => {
            axios
                .get(`https://api.glocart.in/pages/api/app/wishlist/${user.id}`)
                .then((res) => {
                    const wishMap = {};
                    res.data.forEach((item) => {
                        const key = `${item.productId}_${item.variantId}`;
                        wishMap[key] = true;
                    });
                    setWishlist(wishMap);
                })
                .catch((err) => console.error('Error fetching wishlist:', err));
        };

        // Initial fetch
        fetchWishlist();

        // Fetch every 1 second
        const intervalId = setInterval(fetchWishlist, 1000);

        // Clean up interval on unmount
        return () => clearInterval(intervalId);
    }, []);

    console.log('this is glocart')

    return (
        <>
            <Header />

            {/* 🔥 TOP FILTER BAR */}
            <div style={{
                maxWidth: 1200,
                margin: "20px auto",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0 20px"
            }}>

                <button
                    onClick={() => setIsFilterOpen(!isFilterOpen)}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        border: "1px solid #ccc",
                        padding: "8px 14px",
                        background: "#fff",
                        borderRadius: 6,
                        cursor: "pointer",
                        fontWeight: 500
                    }}
                >
                    {/* <span style={{ fontSize: 18 }}><LuSettings2 /></span>  
                      <span style={{ fontSize: 22,fontWeight:'bold' }}><VscSettings /></span>  */}
                    {isFilterOpen ? (
                        <span style={{ fontSize: 18, fontWeight: "bold" }}>
                            <VscSettings />
                        </span>
                    ) : (
                        <span style={{ fontSize: 18 }}>
                            <LuSettings2 />
                        </span>
                    )}
                    Filters
                </button>

                {/* <select
                    style={{
                        border: "1px solid #ccc",
                        padding: "8px 12px",
                        borderRadius: 6
                    }}
                >
                    <option>Best Selling</option>
                    <option>Price: Low to High</option>
                    <option>Price: High to Low</option>
                </select> */}
            </div>

            {/* 🔥 SIDEBAR + PRODUCTS WRAPPER */}
            <div
                // style={{
                //     display: "flex",
                //     maxWidth: 1200,
                //     margin: "auto",
                //     gap: 20,
                //     padding: "0 20px"
                // }}>

                style={{
                    display: "flex",
                    maxWidth: 1200,
                    margin: "auto",
                    gap: 20,
                    padding: "0 20px",
                    flexDirection: window.innerWidth < 768 ? "column" : "row"
                }}
            >


                {/* 🔥 FILTER SIDEBAR */}
                {/* 🔥 FILTER SIDEBAR */}
                {/* <div
    style={{
        width: isFilterOpen ? "260px" : "0px",
        overflow: "hidden",
        transition: "0.3s ease",
        borderRight: isFilterOpen ? "1px solid #ddd" : "none",
        paddingRight: isFilterOpen ? 20 : 0,
        paddingLeft: isFilterOpen ? 10 : 0
    }}
> */}
                {/* <div
                    style={{
                        width: isFilterOpen ? "260px" : "0px",
                        overflow: "hidden",
                        transition: "0.3s ease",
                        borderRight: isFilterOpen ? "1px solid #ddd" : "none",
                        paddingRight: isFilterOpen ? 20 : 0,
                        paddingLeft: isFilterOpen ? 10 : 0,

                        // 🔥 KEEP FILTER FIXED WHILE SCROLLING
                        position: "sticky",
                        top: 0,
                        height: "100vh",
                        overflowY: "auto",
                        background: "#fff",
                        zIndex: 10
                    }}
                >

                    {isFilterOpen && (
                        <>
                            <h3>Filters</h3>

                            <div style={{ marginBottom: 20 }}>
                                <h5>Price (₹0 - ₹{priceRange})</h5>
                                <input
                                    type="range"
                                    min={0}
                                    max={maxPrice}
                                    value={priceRange}
                                    onChange={(e) => setPriceRange(Number(e.target.value))}
                                    style={{ width: "100%" }}
                                />
                            </div>

                            <div style={{ marginBottom: 20 }}>
                                <h5>Brand</h5>
                                {allBrands.map(b => (
                                    <label key={b} style={{ display: "block" }}>
                                        <input
                                            type="checkbox"
                                            checked={selectedBrands.includes(b)}
                                            onChange={() => {
                                                setSelectedBrands(prev =>
                                                    prev.includes(b)
                                                        ? prev.filter(x => x !== b)
                                                        : [...prev, b]
                                                );
                                            }}
                                        />{" "}
                                        {b}
                                    </label>
                                ))}
                            </div>

                            <div style={{ marginBottom: 20 }}>
                                <h5>Country</h5>
                                {allCountries.map(c => (
                                    <label key={c} style={{ display: "block" }}>
                                        <input
                                            type="checkbox"
                                            checked={selectedCountries.includes(c)}
                                            onChange={() => {
                                                setSelectedCountries(prev =>
                                                    prev.includes(c)
                                                        ? prev.filter(x => x !== c)
                                                        : [...prev, c]
                                                );
                                            }}
                                        />{" "}
                                        {c}
                                    </label>
                                ))}
                            </div>

                            <div style={{ marginBottom: 20 }}>
                                <h5>Availability</h5>

                                <label>
                                    <input
                                        type="radio"
                                        checked={availability === "in"}
                                        onChange={() => setAvailability("in")}
                                    />
                                    In Stock
                                </label><br />

                                <label>
                                    <input
                                        type="radio"
                                        checked={availability === "out"}
                                        onChange={() => setAvailability("out")}
                                    />
                                    Out of Stock
                                </label><br />

                                <label>
                                    <input
                                        type="radio"
                                        checked={availability === ""}
                                        onChange={() => setAvailability("")}
                                    />
                                    All
                                </label>
                            </div>

                            <button
                                onClick={() => setIsFilterOpen(false)}
                                style={{
                                    marginTop: 10,
                                    padding: "6px 14px",
                                    borderRadius: 6,
                                    background: "#0057A0",
                                    color: "#fff",
                                    border: "none",
                                    cursor: "pointer"
                                }}
                            >
                                Close
                            </button>
                        </>
                    )}
                </div> */}

                <div
                    style={{
                        width: window.innerWidth < 768
                            ? (isFilterOpen ? "100%" : "0px")
                            : (isFilterOpen ? "260px" : "0px"),

                        position: "sticky",
                        top: 0,
                        height: window.innerWidth < 768 ? "auto" : "100vh",

                        overflow: "hidden",
                        overflowY: "auto",

                        transition: "0.3s ease",

                        borderRight:
                            window.innerWidth < 768
                                ? "none"
                                : (isFilterOpen ? "1px solid #ddd" : "none"),

                        paddingRight: isFilterOpen ? 20 : 0,
                        paddingLeft: isFilterOpen ? 10 : 0,

                        background: "#fff",
                        zIndex: 2000,   // keeps it above products on mobile
                    }}
                >
                    {isFilterOpen && (
                        <>
                            <h3>Filters</h3>

                            {/* PRICE FILTER */}
                            <div style={{ marginBottom: 20 }}>
                                <h5>Price (₹0 - ₹{priceRange})</h5>
                                <input
                                    type="range"
                                    min={0}
                                    max={maxPrice}
                                    value={priceRange}
                                    onChange={(e) => setPriceRange(Number(e.target.value))}
                                    style={{ width: "100%" }}
                                />
                            </div>

                            {/* BRAND FILTER */}
                            <div style={{ marginBottom: 20 }}>
                                <h5>Brand</h5>
                                {allBrands.map(b => (
                                    <label key={b} style={{ display: "block" }}>
                                        <input
                                            type="checkbox"
                                            checked={selectedBrands.includes(b)}
                                            onChange={() => {
                                                setSelectedBrands(prev =>
                                                    prev.includes(b)
                                                        ? prev.filter(x => x !== b)
                                                        : [...prev, b]
                                                );
                                            }}
                                        />{" "}
                                        {b}
                                    </label>
                                ))}
                            </div>

                            {/* COUNTRY FILTER */}
                            <div style={{ marginBottom: 20 }}>
                                <h5>Country</h5>
                                {allCountries.map(c => (
                                    <label key={c} style={{ display: "block" }}>
                                        <input
                                            type="checkbox"
                                            checked={selectedCountries.includes(c)}
                                            onChange={() => {
                                                setSelectedCountries(prev =>
                                                    prev.includes(c)
                                                        ? prev.filter(x => x !== c)
                                                        : [...prev, c]
                                                );
                                            }}
                                        />{" "}
                                        {c}
                                    </label>
                                ))}
                            </div>

                            {/* AVAILABILITY */}
                            <div style={{ marginBottom: 20 }}>
                                <h5>Availability</h5>

                                <label>
                                    <input
                                        type="radio"
                                        checked={availability === "in"}
                                        onChange={() => setAvailability("in")}
                                    />
                                    In Stock
                                </label><br />

                                <label>
                                    <input
                                        type="radio"
                                        checked={availability === "out"}
                                        onChange={() => setAvailability("out")}
                                    />
                                    Out of Stock
                                </label><br />

                                <label>
                                    <input
                                        type="radio"
                                        checked={availability === ""}
                                        onChange={() => setAvailability("")}
                                    />
                                    All
                                </label>
                            </div>
                            {/* SORT FILTER */}
                            <div style={{ marginBottom: 20 }}>
                                <h5>Sort By Price</h5>

                                <label style={{ display: "block" }}>
                                    <input
                                        type="radio"
                                        checked={sortType === "low-high"}
                                        onChange={() => setSortType("low-high")}
                                    />
                                    Low to High
                                </label>

                                <label style={{ display: "block" }}>
                                    <input
                                        type="radio"
                                        checked={sortType === "high-low"}
                                        onChange={() => setSortType("high-low")}
                                    />
                                    High to Low
                                </label>

                                <label style={{ display: "block" }}>
                                    <input
                                        type="radio"
                                        checked={sortType === ""}
                                        onChange={() => setSortType("")}
                                    />
                                    Default
                                </label>
                            </div>


                            <button
                                onClick={() => setIsFilterOpen(false)}
                                style={{
                                    marginTop: 10,
                                    padding: "10px 14px",
                                    borderRadius: 6,
                                    background: "#0057A0",
                                    color: "#fff",
                                    border: "none",
                                    cursor: "pointer",
                                    width: window.innerWidth < 768 ? "100%" : "auto",
                                }}
                            >
                                Close
                            </button>
                        </>
                    )}
                </div>



                {/* 🔥 PRODUCTS GRID */}
                <div style={{ flexGrow: 1 }}>
                    <h4 style={{ textTransform: 'uppercase', marginBottom: '20px' }}>
                        {superCatName ? superCatName.replace('-', ' ') : 'All Products'}
                        {subCatName ? ` / ${subCatName.replace('-', ' ')}` : ''}
                    </h4>

                    <hr />

                    {loading ? (
                        <p>Loading products...</p>
                    ) : products.length === 0 ? (
                        <div className="text-center mt-5" style={{ padding: '40px 20px' }}>
                            <AiOutlineFrown size={80} color="#0057A0" />
                            <h4 className="mt-4 text-muted" style={{ fontWeight: 'bold' }}>
                                No products found for "<span style={{ color: '#0057A0' }}>{filterType?.replace('-', ' ')}</span>"
                            </h4>
                            <button
                                onClick={() => navigate('/')}
                                style={{
                                    marginTop: 20,
                                    backgroundColor: '#0057A0',
                                    color: '#fff',
                                    border: 'none',
                                    padding: '10px 24px',
                                    borderRadius: '6px'
                                }}
                            >
                                🛒 Shop Now
                            </button>
                        </div>
                    ) : (
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
                            gap: 20
                        }}>
                            {/* PRODUCT CARD LOOP (unchanged) */}
                            {products.filter(p => {

                                // ⭐ BRAND FILTER
                                if (selectedBrands.length > 0 && !selectedBrands.includes(p.brand)) {
                                    return false;
                                }

                                // ⭐ COUNTRY FILTER
                                if (selectedCountries.length > 0 && !selectedCountries.includes(p.super_category)) {
                                    return false;
                                }

                                // ⭐ PRICE FILTER (variant final price <= selected price)
                                const lowestVariant = Math.min(
                                    ...p.variants.map(v => computeFinalPrice(v))
                                );
                                if (lowestVariant > priceRange) return false;

                                // ⭐ AVAILABILITY FILTER
                                const hasStock = p.variants.some(v => v.quantity > 0);
                                if (availability === "in" && !hasStock) return false;
                                if (availability === "out" && hasStock) return false;

                                return true;
                            })
                                .sort((a, b) => {
                                    if (sortType === "low-high") {
                                        return (
                                            Math.min(...a.variants.map(v => computeFinalPrice(v))) -
                                            Math.min(...b.variants.map(v => computeFinalPrice(v)))
                                        );
                                    }

                                    if (sortType === "high-low") {
                                        return (
                                            Math.min(...b.variants.map(v => computeFinalPrice(v))) -
                                            Math.min(...a.variants.map(v => computeFinalPrice(v)))
                                        );
                                    }

                                    return 0; // default
                                })
                                .map(p => {
                                    const variant = selectedVariants[p.id];
                                    const qty = quantities[p.id] || 0;
                                    const finalPrice = computeFinalPrice(variant);
                                    const hasDiscount = variant?.discount > 0;

                                    const key = `${p.id}_${variant?.id}`;
                                    const isWishlisted = wishlist[key];
                                    return (
                                        <div key={p.id} style={{
                                            border: '1px solid #e0e0e0',
                                            background: '#fff',
                                            borderRadius: '10px',
                                            position: 'relative'
                                        }}>

                                            {/* Badge */}
                                            {hasDiscount && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: 8,
                                                    left: 8,
                                                    // background: '#4caf50',
                                                     background: "linear-gradient(180deg, #F8EEDB 0%, #F3DFAF 100%)",
                                                    color: '#0058A2',
                                                     fontWeight:'bold',

                                                    padding: '2px 6px',
                                                    fontSize: 12,
                                                    borderRadius: '10px',
                                                }}>
                                                    {variant.discount}% OFF
                                                </div>
                                            )}

                                            {/* Image */}
                                            <div style={{
                                                margin: '16px',
                                                border: '1px solid #eee',
                                                borderRadius: '10px',
                                                backgroundColor: '#fafafa',
                                                padding: 8
                                            }}>
                                                <div onClick={() => navigate(`/product/${p.id}`)} style={{ cursor: 'pointer' }}>
                                                    <img src={p.image_1} alt={p.name} style={{ width: '100%', height: 180, objectFit: 'contain' }} />
                                                </div>
                                            </div>

                                            {/* Details */}
                                            <div style={{ padding: 10 }}>
                                                  <p style={{ fontSize: 11, color: '#000000', marginBottom: 4, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                                            <ReactCountryFlag
                                                                                                countryCode={countryCodeMap[p.super_category]}
                                                                                                svg
                                                                                                style={{ width: '18px', height: '18px' }}
                                                                                            />
                                                                                            {p.super_category}
                                                                                        </p>
                                                <p style={{ fontSize: 11, color: '#4caf50', marginBottom: 4 }}>
                                                    ⚡ {p.category}
                                                </p>
                                                <p style={{ fontSize: 13, margin: 0 }}>{p.brand}</p>
                                                <h4 style={{ fontSize: 14, margin: '4px 0 8px' }}>{p.name}</h4>

                                                {/* Variant Dropdown */}
                                                <div style={{ position: 'relative', marginBottom: 10 }}>
                                                    <div
                                                        style={{
                                                            border: '1px solid #ccc',
                                                            padding: '6px 8px',
                                                            backgroundColor: '#fff',
                                                            cursor: 'pointer',
                                                            fontSize: '13px'
                                                        }}
                                                        onClick={() => handleToggleDropdown(p.id)}
                                                    >
                                                        <strong>₹{finalPrice}</strong>
                                                    </div>

                                                    {variantDropdownOpen[p.id] && (
                                                        <div style={{
                                                            position: 'absolute',
                                                            top: '100%',
                                                            left: 0,
                                                            right: 0,
                                                            background: '#fff',
                                                            border: '1px solid #ccc',
                                                            zIndex: 1000,
                                                            marginTop: 4,
                                                            maxHeight: 200,
                                                            overflowY: 'auto'
                                                        }}>
                                                            {p.variants.map(v => {
                                                                const vFinal = computeFinalPrice(v);
                                                                return (
                                                                    <div key={v.id}
                                                                        onClick={() => handleSelectVariant(p.id, v)}
                                                                        style={{
                                                                            padding: '8px',
                                                                            borderBottom: '1px solid #eee',
                                                                            cursor: 'pointer',
                                                                            background: variant?.id === v.id ? '#f6f6f6' : '#fff'
                                                                        }}>
                                                                        <strong>{v.unit_value} {v.unit}</strong> – ₹{vFinal}
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Add / Increase / Decrease */}
                                                <div className='mt-5' style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between'
                                                }}>
                                                    <button
                                                        style={{
                                                            border: '1px solid #ccc',
                                                            background: '#fff',
                                                            borderRadius: '6px',
                                                            padding: '8px',
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={() => {
                                                            addToWishlist(p, variant);
                                                            // alert(`${p.name} saved to wishlist!`);
                                                            alert(
                                                                isWishlisted
                                                                    ? `${p.name} removed from wishlist!`
                                                                    : `${p.name} saved to wishlist!`
                                                            );
                                                        }}
                                                    >
                                                        {/* <FaRegBookmark /> */}
                                                        {isWishlisted ? (
                                                            <FcBookmark size={22} />     // filled icon
                                                        ) : (
                                                            <FaRegBookmark size={22} />   // empty icon
                                                        )}
                                                    </button>

                                                    {qty > 0 ? (
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            border: '1px solid #0057A0',
                                                            borderRadius: 6,
                                                            overflow: 'hidden'
                                                        }}>
                                                            <button
                                                                onClick={() => {
                                                                    const newQty = qty - 1;
                                                                    if (newQty <= 0) {
                                                                        setQuantities(prev => ({ ...prev, [p.id]: 0 }));
                                                                        removeFromCart(p.id, variant.id);
                                                                    } else {
                                                                        setQuantities(prev => ({ ...prev, [p.id]: newQty }));
                                                                        addToCart({ productId: p.id, variantId: variant.id, name: p.name, image: p.image_1, price: finalPrice }, -1);
                                                                    }
                                                                }}
                                                                style={{ background: '#0057A0', color: '#fff', padding: '6px 35px', border: 'none' }}
                                                            >−</button>

                                                            <div style={{ padding: '6px 12px', fontSize: 14 }}>{qty}</div>

                                                            <button
                                                                onClick={() => {
                                                                    const newQty = qty + 1;
                                                                    setQuantities(prev => ({ ...prev, [p.id]: newQty }));
                                                                    addToCart({ productId: p.id, variantId: variant.id, name: p.name, image: p.image_1, price: finalPrice }, 1);
                                                                }}
                                                                style={{ background: '#0057A0', color: '#fff', padding: '6px 35px', border: 'none' }}
                                                            >+</button>
                                                        </div>
                                                    ) : (
                                                        <button
                                                            onClick={() => {
                                                                setQuantities(prev => ({ ...prev, [p.id]: 1 }));
                                                                addToCart({ productId: p.id, variantId: variant.id, name: p.name, image: p.image_1, price: finalPrice }, 1);
                                                            }}
                                                            style={{
                                                                padding: '6px 90px',
                                                                border: '1px solid #0057A0',
                                                                borderRadius: 6,
                                                                background: '#fff',
                                                                color: '#0057A0'
                                                            }}
                                                        >
                                                            Add
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}

                        </div>
                    )}
                </div>

            </div>

            <Footer />
        </>
    );
};

export default FilteredProducts;
